var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridFiltersPlaceholder = function SvgGridFiltersPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 118,
    fill: "none",
    viewBox: "0 0 120 118"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FE",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M93.872 46.883c0 25.784-20.902 46.686-46.686 46.686S.5 72.667.5 46.883 21.402.197 47.186.197s46.686 20.902 46.686 46.686M10.5 46.697c0-20.159 16.342-36.5 36.5-36.5s36.5 16.341 36.5 36.5-16.342 36.5-36.5 36.5-36.5-16.342-36.5-36.5M47 8.197c-21.263 0-38.5 17.237-38.5 38.5s17.237 38.5 38.5 38.5 38.5-17.237 38.5-38.5-17.237-38.5-38.5-38.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeOpacity: 0.8,
    strokeWidth: 1.174,
    d: "M33.5 18.197c-4.482 2.434-8.266 5.878-11 10M20.493 32.197c-.854 1.39-1.367 2.85-1.493 4.24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0FE",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M92.52 90.824a6.754 6.754 0 0 0 0 9.552l15.449 15.449a6.754 6.754 0 0 0 9.552 0 6.754 6.754 0 0 0 0-9.552l-15.448-15.449a6.755 6.755 0 0 0-9.552 0",
    clipRule: "evenodd"
  })));
};
export default SvgGridFiltersPlaceholder;